export enum StatusInvoice {
    Received_Processing = 1,
    Approved = 2,
    Denied = 3
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/StatusInvoice.ts